import styled from "styled-components";

export const SOnboardingImportingTemplate = styled.div`
  display: flex;
  flex-direction: column;
  margin: 56px auto auto auto;
`;
